/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * Alchemer Dashboard API
 * OpenAPI spec version: 1.0.155
 */

export type ThoughtspotPrivilegeGroup = (typeof ThoughtspotPrivilegeGroup)[keyof typeof ThoughtspotPrivilegeGroup];

export const ThoughtspotPrivilegeGroup = {
  PRIV_ADVANCED_USERS: 'PRIV_ADVANCED_USERS',
  PRIV_STANDARD_USERS: 'PRIV_STANDARD_USERS',
  PRIV_CREATOR_USERS: 'PRIV_CREATOR_USERS',
  PRIV_CONSUMER_USERS: 'PRIV_CONSUMER_USERS',
} as const;
